import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import IncidentsAPI from 'services/IncidentsAPI'
import { getActionStatsRoutine } from 'features/actions/ducks/actions'
import {
  getIncidentsRoutine,
  getIncidentStatsRoutine,
  getIncidentRoutine,
  generateSuggestionsRoutine,
  createIncidentRoutine,
  closeIncidentRoutine,
  presignIncidentAttachmentRoutine,
  confirmIncidentAttachmentRoutine,
} from './actions'
import { toast } from 'react-toastify'
import { toastWithLink } from 'components/ActionToast'
import { PRIVATE_PATHS } from 'utils/paths'

const handle = (routine, fn) => function* (action) {
  try {
    // Forward the trigger payload to REQUEST so the reducer can clear the list
    // immediately when filters change (page-1 fetches), instead of leaving the
    // previous filter's rows visible until the new response lands.
    yield put(routine.request(action.payload))
    const response = yield call(fn, action.payload)
    yield put(routine.success(response?.data))
  } catch (e) {
    yield put(routine.failure(e?.response?.data || { message: e.message }))
  } finally {
    yield put(routine.fulfill())
  }
}

export default function* incidentsSagas() {
  yield takeLatest(getIncidentsRoutine.TRIGGER, handle(getIncidentsRoutine, p => IncidentsAPI.list(p || {})))
  yield takeLatest(getIncidentStatsRoutine.TRIGGER, handle(getIncidentStatsRoutine, p => IncidentsAPI.stats(p || {})))
  yield takeLatest(getIncidentRoutine.TRIGGER, handle(getIncidentRoutine, id => IncidentsAPI.get(id)))
  yield takeLatest(generateSuggestionsRoutine.TRIGGER, handle(generateSuggestionsRoutine, p => IncidentsAPI.suggest(p)))
  yield takeLatest(createIncidentRoutine.TRIGGER, handle(createIncidentRoutine, p => IncidentsAPI.create(p)))
  yield takeLatest(closeIncidentRoutine.TRIGGER, handle(closeIncidentRoutine, id => IncidentsAPI.close(id)))
  yield takeLatest(presignIncidentAttachmentRoutine.TRIGGER, handle(presignIncidentAttachmentRoutine, ({ bpId, ...rest }) =>
    IncidentsAPI.presignAttachment(bpId, rest)))
  yield takeLatest(confirmIncidentAttachmentRoutine.TRIGGER, handle(confirmIncidentAttachmentRoutine, ({ incidentId, ...rest }) =>
    IncidentsAPI.confirmAttachment(incidentId, rest)))

  yield takeEvery(createIncidentRoutine.SUCCESS, function* ({ payload }) {
    const created = payload?.data
    if (created?.id) {
      const raised = Number(created.actionsCount ?? created.actions?.length ?? 0)
      const message = raised > 0
        ? `Incident logged. ${raised} remedial${raised === 1 ? '' : 's'} raised.`
        : 'Incident logged.'
      toastWithLink('success', message, 'Open', PRIVATE_PATHS.incidentDetail.replace(':id', created.id))
    }
    yield put(getActionStatsRoutine({}))
  })
  yield takeEvery(createIncidentRoutine.FAILURE, () => {
    toast.error('The incident was not logged. Your details are still there, so you can try again.')
  })
  yield takeEvery(closeIncidentRoutine.SUCCESS, function* () {
    yield put(getActionStatsRoutine({}))
  })
}
